import { sendChatMessage, setRejected } from "../actions";
import { getIsAudioCall, getIsVideoCall } from "../selectors";
import * as ACTION_TYPES from "../types"

const configuration = {
  iceServers: [
    { urls: "stun:relay1.gooddoc.fun:80" },

    {
      urls: "turn:relay1.gooddoc.fun:80?transport=udp",
      username: "domus",
      credential: "sPy80Hb7o(",
    },
    {
      urls: "turn:relay1.gooddoc.fun:80?transport=tcp",
      username: "domus",
      credential: "sPy80Hb7o(",
    },
  ],
}


export function webrtcTools({dispatch, getState, socket, sendCallMessage, sendRejectMessage, sendEndCallMessage}) {
  let peerConnection = null;
  let iceCandidates = [];
  let myStream = null;
  let localStream = new MediaStream()
  let remoteStream = new MediaStream()
  let isReadyStatus = false; // we need to delete this
  let reserveOptions = {};
  let isVideoCall = false;
  let isMessageConnect = false;
  let isRemoteDescriptionSet = false

  const _createPeerConnect = () => {
    const peer = new RTCPeerConnection(configuration)
    peer.addEventListener("icecandidate", _onIceCandidate)
    // peer.addEventListener("track", onTrack)
    peer.addEventListener("connectionstatechange", _onConnectionStateChange)
    return peer
  }

  const _closePeer = () => {
    peerConnection && peerConnection.close();
    peerConnection = null;
    iceCandidates = []
    reserveOptions = {};
    myStream = null
    localStream = new MediaStream()
    isReadyStatus = false
    remoteStream = new MediaStream()
    isRemoteDescriptionSet = false
  }

  const _onIceCandidate = (rtcp) => {
    if (rtcp.candidate) {
      sendCallMessage({
        type: "candidate",
        candidate: rtcp.candidate,
      })
    }
  }


  const onSocketCandidate = (cand) => {
    const candidate = new RTCIceCandidate(cand);
    if (isRemoteDescriptionSet) {
      peerConnection.addIceCandidate(candidate)
    } else {
      iceCandidates.push(candidate)
    }
    // peerConnection.addIceCandidate(candidate)
    // iceCandidates.push(candidate)
  }

  const _setIceCandidate = () => {
    iceCandidates.forEach((candidate) => {
      peerConnection.addIceCandidate(candidate)
    })
  }

  const _onConnectionStateChange = (event) => {
    if (event.currentTarget.connectionState === "failed") {
      isReadyStatus = false;
      peerConnection.removeEventListener(
        "connectionstatechange",
        _onConnectionStateChange
      );
      _closePeer()
    }
  }

  const createTrackListener = ({ isVideo, userVideo, userAudio }) => {
    peerConnection.addEventListener("track", (event) => {
      console.log("GETTING TRACK", event);
      remoteStream.addTrack(event.track, remoteStream);
      try {
        if (isVideo) {
          userVideo.current.srcObject = remoteStream;
        } else {
          userAudio.current.srcObject = remoteStream;
        }
      } catch (e) {
        console.log("<<<<<<<<<TRACK _______ E R O R R>>>>>>>>", e);
      }
    })
  }

  const createCall = async ({
    partnerVideo,
    consultId,
    patientId,
    doctor,
    isVideo,
    title,
    userVideo,
    userAudio,
  }) => {
    isVideoCall = isVideo
    console.log("createPeerconnect");
    reserveOptions = {
      partnerVideo,
      consultId,
      doctor,
      isVideo,
      title,
      userVideo,
      userAudio,
      patientId,
    };
    peerConnection = _createPeerConnect();
    console.log("creatEE peerConnect");
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: isVideo, audio: true })
      console.log("creatEE peerConnect", stream);
      myStream = stream;
      stream.getTracks().forEach((track) => {
        if (track.kind === "video") {
          localStream.addTrack(track, stream)
        }
        peerConnection.addTrack(track, stream);
      })
      partnerVideo.current.srcObject = localStream
    } catch (e) {
      console.log("stream error", {e});
    }
    createTrackListener({ isVideo, userVideo, userAudio })
    console.log("shdg", doctor);
    sendCallMessage({
      type: "call",
      user_id: patientId,
      customParameters: {
        call_type: isVideo ? "video" : "audio",
        doctor_id: `${doctor.doctor.id}`,
        doctor_name: doctor.fullName,
        doctor_photo: doctor.photoUrl,
        doctor_specialty: title,
        // doctor_specialty_id: doctor.specialty.id,
      },
    })
  }

  // The patient answered, but the peer connection may already be gone: an
  // `ended`/`reject` racing the answer runs stopCall -> _closePeer() and nulls
  // it. Without this guard the TypeError was swallowed by the async handler,
  // no offer was ever sent and the patient sat on "establishing connection"
  // with nothing in the logs to show for it (DS-1730).
  const makeCall = async () => {
    if (!peerConnection) {
      console.error("CALL: offer dropped, peer connection is already closed");
      return;
    }
    try {
      const offer = await peerConnection.createOffer({
        iceRestart: true,
        offerToReceiveAudio: true,
        offerToReceiveVideo: isVideoCall,
      });

      if (!peerConnection) {
        console.error("CALL: offer dropped, peer connection closed while creating the offer");
        return;
      }
      await peerConnection.setLocalDescription(offer);
      sendCallMessage({
        type: "offer",
        offer: offer.sdp,
      })
    } catch (e) {
      console.error("CALL: failed to create the offer", e);
    }
  };

  const catchAnswer = async ({ answer }) => {
    if (!peerConnection) {
      console.error("CALL: answer dropped, peer connection is already closed");
      return;
    }
    if (isVideoCall) {
      dispatch({ type: ACTION_TYPES.START_VIDEO_CALL });
    } else {
      dispatch({ type: ACTION_TYPES.START_AUDIO_CALL });
    }
    const remoteDesc = new RTCSessionDescription({
      type: "answer",
      sdp: answer || answer.nameValuePairs.answer,
    });
    try {
      await peerConnection.setRemoteDescription(remoteDesc);
      isRemoteDescriptionSet = true
      _setIceCandidate()
    } catch (e) {
      console.error("CALL: failed to apply the answer", e);
    }
  };

  const stopCall = ({endedByMe, rejected = false}) => {
    endStream()
    _closePeer()
    const isAudioCall = getIsAudioCall(getState());
    const isVideoCall = getIsVideoCall(getState());
    if (endedByMe) {
      sendCallMessage({
        type: "ended",
        customParameters: {}
      })
    }
    if (endedByMe && !isVideoCall && !isAudioCall) {
      console.log("SEND MISSED CALL");
      sendRejectMessage(true)
    }
    if (!endedByMe && rejected) {
      dispatch(setRejected(true));
      sendRejectMessage(false);
    }
    if (isAudioCall || isVideoCall) {
      console.log("SEND END CALL MESSAGE");
      sendEndCallMessage()
    }
    dispatch({ type: ACTION_TYPES.RESET_CALL });
  };

  const endStream = () => {
    myStream && myStream
      .getTracks().forEach((track) => {
        track.stop();
        myStream.removeTrack(track);
      });
  }

  const muteVideo = () => {
    myStream && myStream
      .getVideoTracks()
      .forEach((track) => (track.enabled = !track.enabled));
  };

  const muteAudio = () => {
    myStream && myStream
      .getAudioTracks()
      .forEach((track) => (track.enabled = !track.enabled));
  };

  return {
    createCall,
    muteVideo,
    muteAudio,
    makeCall,
    onSocketCandidate,
    catchAnswer,
    stopCall,
  }
}